// extracted by mini-css-extract-plugin
module.exports = {"Card":"VideoCardDone_Card__26BMf","Video":"VideoCardDone_Video__3RM3R"};